export default function Footer() {
    return (
        <footer style={{ background: "#1d1d1d", color: "#fff", padding: "30px 20px", marginTop: "50px" }}>
            <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                <div>
                    <h4>Thông tin liên hệ</h4>
                    <p>51 Thép Mới, P.12, Tân Bình, Tp HCM</p>
                    <p>0766630956 | 0936394060</p>
                    <p>Email: buffseo.com@gmail.com</p>
                </div>
                <div>
                    <h4>Dịch vụ marketing</h4>
                    <p>Thiết kế Website</p>
                    <p>Dịch vụ SEO</p>
                    <p>Quản trị Website</p>
                </div>
                <div>
                    <h4>Advertisement</h4>
                    <p>Quảng cáo Facebook</p>
                    <p>Quản trị Fanpage</p>
                    <p>Thiết kế Logo</p>
                </div>
                <div>
                    <h4>Trợ giúp</h4>
                    <p>Thanh toán</p>
                    <p>Giới thiệu</p>
                    <p>Liên hệ</p>
                </div>
            </div>
            <p style={{ textAlign: "center", marginTop: 20, fontSize: 12, color: "#aaa" }}>
                © 2025 BUFF. Điều khoản sử dụng | Chính sách bảo mật
            </p>
        </footer>
    );
}
